const Burger = ({ width = 38, height = 38 }) => (
  <svg width={width} height={height} viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="19" cy="19" r="19" fill="#EEEEEE" />
    <path d="M10.75 19H27.25" stroke="#424242" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.75 13.5H27.25" stroke="#424242" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.75 24.5H27.25" stroke="#424242" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Burger;
